export default __webpack_public_path__ + "static/media/DFSrecInfo.f7746a85.md";